import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import FONTS from '@mlb/react-patterns/style/fonts.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';
import Icon from '@mlb/react-patterns/components/Icon/icon.tsx';

import Container from '../../containers/TwitterButton';
import { useDictionary } from '../../hooks/config';

const Content = styled.div`
    color: ${COLORS.mlbWhite};
    height: 32px;
    max-width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 13px;
    transition: 0.2s;
    border-radius: 5px;
    font-weight: bold;
    vertical-align: bottom;
    background-color: ${COLORS.transparent};
    border: 1px solid ${COLORS.mlbGrey2};
    display: flex;
    align-items: center;
    span {
        white-space: nowrap;
        display: inline-block;
        margin-left: 5px;
        font-family: ${FONTS.primaryFont};
    }
    &:hover {
        cursor: pointer;
        background-color: ${COLORS.mlbGrey6};
    }
`;

const TwitterButton = ({
    mediaPlayback,
    onClick,
    twitterButtonRef,
    className,
}) => {

    const {
        tweet_video = 'Tweet Video',
    } = useDictionary();

    return (
        <Container mediaPlayback={mediaPlayback} onClick={onClick} ref={twitterButtonRef}>
            <Content className={className}>
                <Icon
                    name={'twitter'}
                    fill={COLORS.mlbWhite}
                    width={17}
                />
                <span>{tweet_video}</span>
            </Content>
        </Container>
    );

};

TwitterButton.propTypes = {
    mediaPlayback: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    twitterButtonRef: PropTypes.object,
};

TwitterButton.defaultProps = {
    onClick: _noop,
    twitterButtonRef: undefined,
};

export default TwitterButton;
